import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../msal/MsalConfig";
import { Button } from '@mui/material';
import LoginOutlinedIcon from '@mui/icons-material/LoginOutlined';
export const SignInButton = () => {
    const { instance } = useMsal();

    const handleLogin = (loginType) => {
        if (loginType === "redirect") {
            instance.loginRedirect(loginRequest).catch(e => {
                console.log(e);
            });
        }
    }
    return (
        <Button variant="text" sx={{color: '#ffffff'}} alt="Sign In" onClick={() => handleLogin("redirect")}><LoginOutlinedIcon  /></Button>
    );
}